import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { dggTheme } from 'src/styles/dggTheme';
import { breakpoint } from 'src/styles/dontgiftguide.styles';

const { spacing } = dggTheme;

export const featureSection = css`
  width: 350px;
  border-radius: 30px;
  margin: 0 auto ${pxToRem(spacing.xl)};
  padding: ${pxToRem(16)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      margin-bottom: ${pxToRem(spacing.xxxxl)};
      width: 614px;
    `,
  )}

  a {
    display: block;
  }
`;

export const product = css`
  margin-bottom: ${pxToRem(24)};
  position: relative;
`;

export const productLabel = css`
  font-size: ${pxToRem(14)};
  line-height: normal;

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(24)};
    `,
  )}
`;

export const link = css`
  text-decoration: none;
  color: inherit;
`;

export const circleImage = css`
  height: 300px;
  width: 300px;
  border-radius: 50%;
  object-fit: cover;

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: 500px;
      width: 500px;
    `,
  )}
`;

export const archImage = css`
  height: 400px;
  width: 300px;
  border-radius: 200px 200px 30px 30px;
  object-fit: cover;

  ${mediaQuery(
    { min: breakpoint },
    css`
      height: 700px;
      width: 500px;
      border-radius: 400px 400px 30px 30px;
    `,
  )}
`;

export const copy = css`
  margin-bottom: ${pxToRem(24)};
  font-size: ${pxToRem(18)};
  line-height: ${pxToRem(22)};

  ${mediaQuery(
    { min: breakpoint },
    css`
      font-size: ${pxToRem(24)};
      line-height: ${pxToRem(28)};
    `,
  )}
`;

export const stickerContainer = css`
  display: inline-block;
  position: absolute;
`;

export const topLeftSticker = css`
  top: -25px;
  left: -12px;

  ${mediaQuery(
    { min: breakpoint },
    css`
      top: -70px;
      left: -70px;
    `,
  )}
`;

export const bottomRightSticker = css`
  bottom: 0;
  right: 0;

  ${mediaQuery(
    { min: breakpoint },
    css`
      bottom: -10px;
      right: -45px;
    `,
  )}
`;
